import { ErrorResponse } from "utils/interfaces"
import { bookSessionUrl } from "modules/Booking/FormPage/common/api"
import { SentryWrapper } from "utils/ThirdParty/Sentry/SentryWrapper"

export function sentryBookSessionError(onlyFree: boolean, response: ErrorResponse) {
    SentryWrapper.getInstance().captureException(
        new Error(`Request ${bookSessionUrl(onlyFree)} return 200, but failed (Booking)`),
        {
            extra: {
                response,
            },
        }
    )
}
